import * as React from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { InputField, Input, DateField, Date, AutoCompleteField, AutoComplete } from '@components/form';
import { itemStateEnum } from './_operationalWarehouseEnums';
import { get } from 'lodash';

const FORM_NAME = 'module-operational-warehouse-histories';

const enhance = compose<any, any>(
  reduxForm({ form: FORM_NAME }),
  connect<any>(state => ({
    beforeState: formValueSelector(FORM_NAME)(state, 'before.state'),
    afterState: formValueSelector(FORM_NAME)(state, 'after.state')
  }))
);

export const View = ({ closeItem, beforeState, afterState }) => {
  const isBeforeIssued = beforeState === 'ISSUED';
  const isAfterIssued = afterState === 'ISSUED';

  return (
    <form className="layout">
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col xs={12}>
            <h3>Historie</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <InputField component={Input} id="user" name="user" label="Uživatel" disabled={true} />
          </Col>
          <Col xs={12} md={6}>
            <DateField
              component={Date}
              id="created"
              name="created"
              label="Datum a Čas"
              dateOnly={false}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <AutoCompleteField
              component={AutoComplete}
              id="before.state"
              name="before.state"
              label="Stav předmětu před změnou"
              disabled={true}
              items={itemStateEnum}
              valueFunction={o => get(o, 'id')}
              labelFunction={o => get(o, 'label')}
            />
          </Col>
          <Col xs={12} md={6}>
            <AutoCompleteField
              component={AutoComplete}
              id="after.state"
              name="after.state"
              label="Stav předmětu po změně"
              disabled={true}
              items={itemStateEnum}
              valueFunction={o => get(o, 'id')}
              labelFunction={o => get(o, 'label')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <InputField component={Input} id="after.note" name="after.note" label="Poznámka" disabled={true} />
          </Col>
        </Row>
        {(isBeforeIssued || isAfterIssued) && (
          <Row>
            <Col xs={12} md={6} xl={4}>
              <InputField
                component={Input}
                id="before.employee.fullName"
                name="before.employee.fullName"
                label={
                  isBeforeIssued
                    ? 'Zaměstnanec, kterému byl předmět odebrán'
                    : 'Zaměstnanec, kterému byl předmět přidělen'
                }
                disabled={true}
              />
            </Col>
          </Row>
        )}
      </Grid>

      <Divider />

      <Button label="Zavřít" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  );
};

export const operationalWarehouseFormHistoriesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseFormHistoriesForm.tsx